module.exports = __webpack_public_path__ + "static/media/8-mobile.aba7754f.jpg";